import { PostFetch } from "../../services/apiBase";

const VerifyLogin = async () => {

    const token = localStorage.getItem('@JWT_HASH')
    if (!token) {
        localStorage.removeItem('authenticated');
        localStorage.removeItem('@JWT_HASH');
    } else {
        try {
            await PostFetch('/subscription/loginByToken');
        } catch (error) {
            localStorage.removeItem('authenticated');
            localStorage.removeItem('@JWT_HASH');
            
        }
       
    }

}

export default VerifyLogin;